/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const DeployRequest = zod
	.object({
		note: zod.string().optional().describe('Optional deploy note')
	})
	.describe('Request body for deploying a praetor draft');

export type DeployRequest = zod.input<typeof DeployRequest>;
export type DeployRequestOutput = zod.output<typeof DeployRequest>;
